module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Admin")]), (_vm.isLoading) ? _c('h3', [_vm._v("Loading...")]) : [_vm._l((_vm.numbers), function(num) {
    return [_c('div', {
      staticClass: "well admin-number text-center"
    }, [_c('i', {
      staticClass: "fa fa-2x",
      class: num.icon
    }), _c('br'), _c('small', [_vm._v(_vm._s(num.name))]), _c('h3', [_vm._v(_vm._s(num.nb))])])]
  }), _vm._l((_vm.charts), function(chart) {
    return [_c('highcharts', {
      attrs: {
        "options": chart.options
      }
    }), _c('hr')]
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ea470bc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Administration/Administration.vue
// module id = 893
// module chunks = 13